export default {"src":"/_next/static/media/right-red-dot.7cf33aae.svg","height":12,"width":20};